import { NgModule, Optional, SkipSelf } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { ClaimLandingComponent } from './claim/claim-landing/claim-landing.component';
// components/directives/pipes
import { PolicyLandingComponent } from './policy/policy-landing/policy-landing.component';

@NgModule({
  imports: [SharedModule],
  declarations: [ClaimLandingComponent, PolicyLandingComponent],
  exports: [ClaimLandingComponent, PolicyLandingComponent],
  providers: []
})
export class BusinessModule {
  constructor(@Optional() @SkipSelf() parentModule: BusinessModule) {
    if (parentModule) {
      throw new Error('BusinessModule is already loaded. Lazy load only');
    }
  }
}
